import React, { useContext, useState } from 'react';
import { Button, TextField } from '@material-ui/core';
import { MultiStepContext } from '../StepContext5';

export default function Questions2() {
    const { setStep, instructorData, setInstructorData, instructorsubmitData } = useContext(MultiStepContext);
    const [error, setError] = useState(null);

    const handleSubmit = () => {
        if (!instructorData.ans1 || !instructorData.ans2 || !instructorData.ans3) {
            setError("Please fill in all fields.");
        } else {
            setError(null);
            instructorsubmitData();
        }
    };

    return (
        <div>
            <h4 style={{textAlign:'center'}}>Security Questions</h4>
            <div className="flx-adrs"> 
            <TextField
                style={{width:'100%'}}
                label="Your Primary School Name"
                margin='normal'
                value={instructorData['ans1'] || ''}
                onChange={(e) => setInstructorData({ ...instructorData, "ans1": e.target.value })}
                variant='outlined'
            />
            </div>
            <div className="flx-adrs"> 
            <TextField
                style={{width:'100%'}}
                label="Your Favourite Food"
                margin='normal'
                value={instructorData['ans2'] || ''}
                onChange={(e) => setInstructorData({ ...instructorData, "ans2": e.target.value })}
                variant='outlined'
            />
            </div>
            <div className="flx-adrs"> 
            <TextField
                style={{width:'100%'}}
                label="Your Best Friend Name"
                margin='normal'
                value={instructorData['ans3'] || ''}
                onChange={(e) => setInstructorData({ ...instructorData, "ans3": e.target.value })}
                variant='outlined'
            />
            </div>
            {error && <p style={{color: 'red'}}>{error}</p>}
            <div className="signupbtnn">  
                <Button variant='contained' onClick={() => setStep(1)} color='secondary'>Back</Button>
                <Button variant='contained' style={{float:'right'}} onClick={handleSubmit} color='primary'>Submit</Button> 
            </div>    
        </div>
    );
}
